<div class="app-layout-overlapped-modals" [ngClass]="{'with-overlay': showPlayer || showDone }">
  <core-layout-modal-record-player
      *ngIf="showPlayer"
      [buttonText]="'Save recording'"
      [leftButtonText]="'Cancel'"
      (action)="onRecordSave($event)"
      (leftButtonAction)="onRecordCancel($event)"
  ></core-layout-modal-record-player>
  <core-layout-modal-feedback
      *ngIf="showDone"
      [type]="'success'"
      [message]="'Success'"
      [text]="'Your message has been saved successfully.'"
      [buttonText]="'OK'"
      (action)="onMessageSent($event)">
  </core-layout-modal-feedback>
  <core-layout-modal-feedback class="modal-feedback" 
      *ngIf="showError"
      [type]="'fail'"
      [message]="'Error'"
      [text]="'Something went wrong saving your message. Please try again. <br/>If the error persists, please reach out to our support team through the Help Me button.'"
      [buttonText]="'OK'"
      (action)="onMessageError($event)">
    </core-layout-modal-feedback>
  <core-layout-float-pip-camera-player
    *ngIf="showPipCam"
  ></core-layout-float-pip-camera-player>
</div>